export {
  serverFortnoxPublicPages as fortnoxPublicPages,
  serverFortnoxPublicPagePaths as fortnoxPublicPagePaths,
  serverFortnoxPublicPageRegistryInvariant as fortnoxPublicPageRegistryInvariant,
  findServerFortnoxPublicPageByPath as getFortnoxPublicPageByPath,
  buildFortnoxPublicJsonLd,
  fortnoxPublicShared,
  localizeFortnoxHref
} from "../../server/fortnoxPublicPages";
export type {
  FortnoxPublicPageKey,
  FortnoxPublicPagePath,
  ServerFortnoxPublicPage as FortnoxPublicPageContent
} from "../../server/fortnoxPublicPages";
import { serverFortnoxPublicPages } from "../../server/fortnoxPublicPages";
export const fortnoxPublicPagesContractId = "dynamicbooks.fortnox.public-pages.v2";
export const listFortnoxPublicPages = () => serverFortnoxPublicPages;
export const fortnoxPublicLockedFacts = [
  {label:"Connect",value:"249 SEK per företag och månad — planerat"},
  {label:"Connect Byrå",value:"399 SEK per byrå och månad — planerat"},
  {label:"Tillgänglighet",value:"Inte tillgänglig för allmän aktivering"}
] as const;
export const isFortnoxPublicPath = (path:string) => path==="/fortnox" || path.startsWith("/fortnox/");
// The v1 preparation contract is superseded; locale/content/route parity is verified
// by the v2 readiness contracts, not by the old eight-route schema.
export const fortnoxPublicPageSchema = {
  $schema:"https://json-schema.org/draft/2020-12/schema",
  type:"object",
  additionalProperties:false,
  required:Object.keys(serverFortnoxPublicPages[0]!),
  properties:{
    schema:{const:"dynamicbooks.fortnox.public-page.v2"},
    key:{enum:serverFortnoxPublicPages.map(p=>p.key)},
    path:{enum:serverFortnoxPublicPages.map(p=>p.path)},
    assetKey:{type:"string"},
    canonicalUrl:{type:"string",pattern:"^https://dynamicbooks\\.se/fortnox"},
    locale:{enum:["sv","en"]},localeTag:{enum:["sv-SE","en"]},
    nav:{type:"string"},title:{type:"string"},metaDescription:{type:"string"},h1:{type:"string"},lead:{type:"string"},
    pageKind:{enum:["hub","product","guide","pricing","consultant","legal","support","status"]},
    pricing:{type:"boolean"},
    bodySections:{type:"array",minItems:3,items:{type:"object",additionalProperties:false,required:["id","title","body"],properties:{id:{type:"string"},title:{type:"string"},body:{type:"string"},items:{type:"array",items:{type:"string"}},link:{type:"string"},linkLabel:{type:"string"}}}},
    ctas:{type:"array",items:{type:"object",additionalProperties:false,required:["id","label","href","kind"],properties:{id:{type:"string"},label:{type:"string"},href:{type:"string"},kind:{enum:["primary","secondary","text"]},requiresAuthentication:{type:"boolean"}}}},
    disclosures:{type:"object",additionalProperties:false,required:["integrationId","publicationState","liveExecutionEnabled","providerApprovalClaimed","fortnoxPublicationSubmitted","legalReviewStatus"],properties:{integrationId:{const:"43423"},publicationState:{const:"unpublished"},liveExecutionEnabled:{const:false},providerApprovalClaimed:{const:false},fortnoxPublicationSubmitted:{const:false},legalReviewStatus:{enum:["draft_pending_review","external_approval_pending"]}}},
    registryInvariant:{const:serverFortnoxPublicPages[0]!.registryInvariant},
    sourceRefs:{type:"array",items:{type:"string"}},
    jsonLdTypes:{type:"array",items:{enum:["Organization","WebPage","BreadcrumbList","SoftwareApplication","Service"]}},
    seo:{type:"object",additionalProperties:false,required:["robotsProduction","robotsNonProduction","sitemap","jsonLdTypes"],properties:{robotsProduction:{const:"index,follow"},robotsNonProduction:{const:"noindex,nofollow"},sitemap:{const:true},jsonLdTypes:{type:"array",items:{type:"string"}}}},
    social:{type:"object",additionalProperties:false,required:["ogImage","twitterImage","imageAlt","width","height","twitterWidth","twitterHeight"],properties:{ogImage:{type:"string"},twitterImage:{type:"string"},imageAlt:{type:"string"},width:{const:"1200"},height:{const:"630"},twitterWidth:{const:"1200"},twitterHeight:{const:"600"}}}
  }
} as const;
